import React from "react";
import "./style.scss";
const Login = (props) => {
  return (
    <div className="login">
      <div className="login-header">Sign In</div>
      <div className="login-email">
        <div>Email address</div>
        <input
          type="text"
          placeholder="Enter email"
          onChange={props.handleEmailChange}
        ></input>
      </div>
      <div className="login-psw">
        <div>Password</div>
        <input
          type="password"
          placeholder="Enter Password"
          onChange={props.handlePswChange}
        ></input>
      </div>
      {/* <div className="login-remember">
        <input
          type="checkbox"
          checked={props.checked}
          onChange={props.handleCheckChange}
        ></input>
        <div>Keep Me Logged In</div>
      </div> */}
      <button className="login-button" onClick={props.handleClickSubmit}>
        Submit
      </button>
      <div className="login-error">{props.error}</div>
    </div>
  );
};

export default Login;
